export default __webpack_public_path__ + "static/media/pic4.6b439895.jpg";